import { AgentForm } from '@/components/forms/AgentForm';
import { PageContainer } from '@/components/PageContainer';
import { Card } from '@televet/kibble-ui/Card';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/agents/add')({
  component: RouteComponent,
  beforeLoad: () => {
    return {
      pageTitle: 'Add Agent',
    };
  },
});

function RouteComponent() {
  return (
    <PageContainer>
      <AgentForm />
    </PageContainer>
  );
}
